module.exports = __webpack_public_path__ + "static/network2-1bbcac64efdcac5f5fc1443e10060e20.png";